import { render, staticRenderFns } from "./CertificationImporterView.vue?vue&type=template&id=5e908178&"
import script from "./CertificationImporterView.vue?vue&type=script&lang=js&"
export * from "./CertificationImporterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports